import ProductGiftsProvider from './hooks/useProductGifts';

import { ProductGiftsProps } from './@types/ProductGiftsProps';

const ProductGifts = (props: ProductGiftsProps) => (
	<ProductGiftsProvider {...props}>
		<div className="vtex-product-gifts-0-x-productGiftsContainer productGiftsContainer">{props.children}</div>
	</ProductGiftsProvider>
);

export default ProductGifts;
